import React from "react";
import { Notyf } from 'notyf';
import * as api from './api';
import * as bm from './BookmarkManagement'

const ADDITIONAL_ACTION_ADD_TO_BOOKMARKS = "ADDITIONAL_ACTION_ADD_TO_BOOKMARK"
const ADDITIONAL_ACTION_ADD_TO_PLAYLIST = "ADDITIONAL_ACTION_ADD_TO_PLAYLIST"

function storeMailAddress(mail) {
  api.storeMailAddress(mail);
};

  function addClipToPlaylist(playlistElements,setPlaylistElements,item) {

      const notyf = new Notyf(
        {
          dismissible: true
        }
      );

    let index = playlistElements.findIndex(element => element.id === item.id);
    if (index !== -1) {
      notyf.error({
        message: '"' + item.title + '"' + " is already in your playlist.", duration: 5000, position: {
          x: 'right', // 'left', 'center' oder 'right'
          y: 'top'    // 'top' oder 'bottom'
        }

      });
    }
    else {
      setPlaylistElements([...playlistElements, item]);
      notyf.success({
        message: '"' + item.title + '"' + " added successfully to your playlist.", duration: 5000, position: {
          x: 'right', // 'left', 'center' oder 'right'
          y: 'top'    // 'top' oder 'bottom'
        }
      });
    }
  }

function removeChild(id, rows, setRows) {
  let newRows = rows.filter(row => row.id !== id);
  setRows(newRows);
}


function addJob(rows, type, url, mail, setRows, onBeforeApiCall = () => { },openSelectLanguageForm = () => {}, lang=null) {


  const languageCallbackFunction = (selected_language=null) => {
    if(selected_language==null){
      alert("No language was selected. Please try again and select a language.");
      removeChild(id, rows, setRows);
      return;
    }

    addJob(rows, type, url, mail, setRows, onBeforeApiCall, openSelectLanguageForm, selected_language);

  };

  const notyf = new Notyf(
    {
      dismissible: true
    }
  );

  if (type === "") {
    alert("Please select a format");
    return;
  }

  for (var k in rows) {
    if (rows[k].url === url && rows[k].type === type) {
      alert("This clip is aleady in your queue!");
      return;
    }
  }
  let id = -rows.length - 1;
  let newRow = { id: id, ts_start: Date.now() / 1000, ts_last_action: Date.now() / 1000, status: 0, title: url, url: url, type: type};
  let r = rows.concat([newRow]);
  let url2 = url;
  //setUrl(""); onSucess
  onBeforeApiCall()
  setRows(r);
  api.addJob(
    url2,
    type,
    lang,
    (json) => {
      //console.log(url);
      if (json.title != null) {

        if(json.multi_language & lang==null){
          openSelectLanguageForm([
            languageCallbackFunction,
            json.languages
          ]);
          return;
        }

        storeMailAddress(mail);
        let newRows = r;
        for (let i = 0; i < newRows.length; i++) {
          if (newRows[i].id === id) {
            newRows[i] = json;
            setRows([]);
            setRows(newRows);
            notyf.success({
              message: 'Your clip was added successfully to your queue.', duration: 10000, position: {
                x: 'right', // 'left', 'center' oder 'right'
                y: 'down'    // 'top' oder 'bottom'
              }
            });
            break;
          }

        }

      }
      else {
        removeChild(id, rows, setRows);
        // notyf.error('Invalid URL: ' + url2);
        alert("Invalid URL: " + url2);
      }

    })

};

  function addBookmark(url,title=null) {

    const validateAndPerform = (url,title) => {
        let result = bm.addBookmark(url, title);
      if (result == bm.CLIP_ADDED_SUCCESSFULLY_INTO_LIST)
        notyf.success({
          message: 'The clip "' + title + '"' + " was added successfully into your bookmark list.", duration: 5000, position: {
            x: 'right', // 'left', 'center' oder 'right'
            y: 'top'    // 'top' oder 'bottom'
          }
        });
      else if (result == bm.CLIP_ALREADY_IN_LIST) {
        notyf.error({
          message: 'The clip "' + title + '"' + " is already in your bookmark list.", duration: 5000, position: {
            x: 'right', // 'left', 'center' oder 'right'
            y: 'top'    // 'top' oder 'bottom'
          }
        });
      }
    }
    
  const notyf = new Notyf(
    {
      dismissible: true
    }
  );

  if(title != null && url != null){
    validateAndPerform(url,title);
    return;
  }

    notyf.success({
      message: 'The clip process was initiated.', duration: 5000, position: {
        x: 'right', // 'left', 'center' oder 'right'
        y: 'top'    // 'top' oder 'bottom'
      }
    });

    const callback_fun = (data) => {
      if (data.title == null) {
        alert("Invalid URL: " + url);
        return;
      }

      validateAndPerform(data.url,data.title);
    };

    api.getClipInformation(url,callback_fun);


  }

export { addJob, addBookmark, addClipToPlaylist,ADDITIONAL_ACTION_ADD_TO_BOOKMARKS,ADDITIONAL_ACTION_ADD_TO_PLAYLIST }